<template>
  <div>
    <SGPMainTabComponent >
      <SGPTabComponent title="Tarefas">
        <TarefaMobilidadePage></TarefaMobilidadePage>
      </SGPTabComponent>
      <!-- <SGPTabComponent title="Filtro de Mobilidades">
        <TarefasMobilidadeFiltros />
      </SGPTabComponent>
      <SGPTabComponent title="Filtro de Formulários">
        <FormulariosFiltros />
      </SGPTabComponent> -->
    </SGPMainTabComponent >
  </div>
</template>

<script>
import TarefaMobilidadePage from './TarefaMobilidadePage.vue'
// import TarefasMobilidadeFiltros from './TarefasMobilidadeFiltros'
// import FormulariosFiltros from './FormulariosFiltros'
export default {
  name: 'TarefaMobilidadeAbas',
  components: { 
    TarefaMobilidadePage, 
    // TarefasMobilidadeFiltros, 
    // FormulariosFiltros 
  }
}
</script>